// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MFPL","footer":"styles_footer__1Sbpv","passCodeTooltip":"styles_passCodeTooltip__3-4_6"};